import { apiClient } from "./client";

/** Một cổng thanh toán phòng khám chọn được (tầng 3 của ADR-0050). */
export type GatewayOption = {
  code: string;
  name: string;
  /** Có hoàn tiền qua API không — lý do duy nhất để bước lên tầng này. */
  refundApi: boolean;
  note: string;
};

/** Cấu hình đã lưu. Không có trường nào mang khoá bí mật: chỉ biết CÓ hay KHÔNG. */
export type GatewayConfig = {
  id: string;
  provider: string;
  providerName: string;
  merchantCode: string;
  hasSecret: boolean;
  refundApi: boolean;
  active: boolean;
};

/** Mức dùng so với trần gói bao. `capVnd` null = gói không bao, phòng khám tự trả phí cổng. */
export type GatewayUsage = {
  month: string;
  capVnd: number | null;
  usedVnd: number;
  overageVnd: number;
};

export type SaveGateway = {
  provider?: string;
  merchantCode: string;
  /** Bỏ trống khi sửa = giữ khoá cũ. Màn hình không đọc lại được nó để gửi kèm. */
  secret?: string;
};

const BASE = "/v1/billing/payment-gateway";

export const paymentGatewayApi = {
  options: () => apiClient.get<GatewayOption[]>(`${BASE}/options`).then((r) => r.data),
  list: () => apiClient.get<GatewayConfig[]>(BASE).then((r) => r.data),
  usage: () => apiClient.get<GatewayUsage>(`${BASE}/usage`).then((r) => r.data),
  create: (body: SaveGateway) => apiClient.post<string>(BASE, body).then((r) => r.data),
  update: (id: string, body: SaveGateway) => apiClient.put<void>(`${BASE}/${id}`, body),
  activate: (id: string) => apiClient.post<void>(`${BASE}/${id}/activate`),
  disableAll: () => apiClient.post<void>(`${BASE}/disable`),
};

export const paymentGatewayQueryKeys = {
  options: () => ["billing", "payment-gateway", "options"] as const,
  list: () => ["billing", "payment-gateway", "list"] as const,
  usage: () => ["billing", "payment-gateway", "usage"] as const,
};
